// extracted by mini-css-extract-plugin
export default {"addressOption":"SavedAddressOption-module__addressOption___3fFSL","addressName":"SavedAddressOption-module__addressName___3mERN"};